import React, { memo } from 'react';
import FileName from '../../../../features/files/components/FileName/FileName';

/**
 * Memoized list title + file progress; avoids re-rendering when only the edit toolbar / selection changes.
 */
function TaskTableListHeader({
  fileName,
  isEditing,
  onFileNameClick,
  onFileNameBlur,
  onFileNameKeyDown,
  tasks,
  currentFileId,
  files,
  currentFile,
  hasUnsavedChanges,
  hasRestoredDraft,
  loggedOutWorkspaceSnapshot,
  editHighlightAnchorRef,
  onEditHighlightAnchorReady
}) {
  return (
    <div className="task-view-top-header-filename">
      <FileName
        fileName={fileName || ''}
        isEditing={isEditing}
        onFileNameClick={onFileNameClick}
        onFileNameBlur={onFileNameBlur}
        onFileNameKeyDown={onFileNameKeyDown}
        tasks={tasks}
        currentFileId={currentFileId}
        files={files}
        currentFile={currentFile}
        hasUnsavedChanges={hasUnsavedChanges}
        hasRestoredDraft={hasRestoredDraft}
        loggedOutWorkspaceSnapshot={loggedOutWorkspaceSnapshot}
        editHighlightAnchorRef={editHighlightAnchorRef}
        onEditHighlightAnchorReady={onEditHighlightAnchorReady}
        showSaveButton={false}
      />
    </div>
  );
}

export default memo(TaskTableListHeader);
